import { PresenceColorProvider } from '@fluidx/office-fluid-types';
import { ITelemetryBaseLogger } from '@fluidframework/common-definitions';
import { sendErrorEvent } from '..';

export async function resolvePresenceColor(
  presenceColorProvider: PresenceColorProvider,
  userId: string,
  logger: ITelemetryBaseLogger | undefined
): Promise<string> {
  try {
    return await presenceColorProvider.getPresenceColorForUser(userId);
  } catch (e) {
    logger &&
      sendErrorEvent(
        logger,
        {
          eventName: 'ErrorFetchingPresenceColorForUser'
        },
        e
      );
    // return the empty string as a fallback value
    return '';
  }
}
